import * as angular from "angular";
import {IController} from "angular";
import {AgentModel} from "../../angular/models/agent.model";
import {TaskModel} from "../../../tasks/models/task.model";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";

export class AgentPerformanceTaskCardComponent implements IController {

  task: TaskModel;
  taskIrregularties: any[];
  taskNumber: number;
  taskPackageData: any;
  onTaskClick: Function;

  public purposeToServiceType: any;
  public distanceUnit: string;
  public isExpanded: boolean = false;

  constructor(private tasksConstants, private splitService: SplitService) {
  }

  $onInit() {
    this.purposeToServiceType = this.tasksConstants.purposeToServiceType;
    this.distanceUnit = this.splitService.getSiteDistanceLargeUnit();
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentPerformanceTaskCard', {
    bindings: {
      task: '<',
      taskIrregularties: '<',
      taskNumber: '<',
      taskPackageData: '<',
      onTaskClick: '&',
    },
    template: require('./agent-performance-task-card.html').default,
    controller: AgentPerformanceTaskCardComponent
  });
